var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.98096 13.2045L1.10166 11.3252C0.699879 10.9235 0 11.2086 0 11.7918V17.352C0 17.7149 0.285135 18 0.648036 18H6.20818C6.79141 18 7.07655 17.3001 6.67477 16.8983L4.79546 15.019L7.6209 12.2195C8.12637 11.7141 8.12637 10.8846 7.6209 10.3791C7.11543 9.87363 6.28594 9.87363 5.78048 10.3791L2.98096 13.2045Z",
    fill: "#454F5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.019 4.79546L16.8983 6.67477C17.3001 7.07655 18 6.79141 18 6.20818V0.648036C18 0.285135 17.7149 0 17.352 0H11.7918C11.2086 0 10.9235 0.699879 11.3252 1.10166L13.2045 2.98096L10.3791 5.78048C9.87363 6.28594 9.87363 7.11543 10.3791 7.6209C10.8846 8.12637 11.7141 8.12637 12.2195 7.6209L15.019 4.79546Z",
    fill: "#454F5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenModal);
export default __webpack_public_path__ + "static/media/openModal.af69be88fa555ee80be8156f6bb6ec52.svg";
export { ForwardRef as ReactComponent };